<template>
  <el-dropdown trigger="click" class="international" @command="handleSetMap">
    <div :title="$t('titles.mapChange')">
      <i class="el-icon-s-promotion"></i>
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item :disabled="map==='gdMap'" command="gdMap">
        天地图
      </el-dropdown-item>
      <el-dropdown-item :disabled="map==='ggMap'" command="ggMap">
        Google
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  computed: {
    map() {
      return this.$store.state.map
    }
  },
  methods: {
    handleSetMap(value) {
      this.$store.dispatch('setMap', value)
      this.$router.go(0)
    }
  }
}
</script>

